import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Link } from 'react-router';
import UrlHelpers from '../../../shared/url_helpers';

const CategorySearchPill = ({ category }) => {
  if (!category) { return null; }

  return (
    <li className="category-filter filter-term">
      {category.name}
      <Link rel="nofollow" className="filter-term-remove ml-half" to={UrlHelpers.softwarePath()}>
        <span className="fa fa-times" />
      </Link>
    </li>
  );
};

CategorySearchPill.propTypes = {
  category: PropTypes.object,
};

export default CategorySearchPill;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/search_pills/category_search_pill.jsx